export default [
  {
    key: 'increasement',
    sortable: true,
    sortField: 'createdAt',
  label: 'label.no',
    thClass: 'w-50px',
  },
  {
    key: 'name',
    label: 'field.title',
    stickyColumn: true,
    variant: 'light',
  },
  {
    key: 'task',
    label: 'field.ability',
  },
  {
    key: 'serviceSystem',
    label: 'field.serviceSystem',
  },
  {
    key: 'totalWorkflowStep',
    label: 'field.totalWorkflowSteps',
  },
  {
    key: 'createdAt',
    sortable: true,
    sortField: 'createdAt',
    label: 'field.createDate',
  },
  {
    key: 'isActive',
    label: 'field.status',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
]
